import { render, staticRenderFns } from "./BrowserAgentChatMessages.vue?vue&type=template&id=168f4bc3&scoped=true"
import script from "./BrowserAgentChatMessages.vue?vue&type=script&lang=js"
export * from "./BrowserAgentChatMessages.vue?vue&type=script&lang=js"
import style0 from "./BrowserAgentChatMessages.vue?vue&type=style&index=0&id=168f4bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f4bc3",
  null
  
)

export default component.exports